<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <div class="tbl-scroll-host cat-list-host">
                <div class="cat-list" v-loading="listLoading">
                    <div v-if="!listLoading && !(displayTree && displayTree.length)" class="cat-list__empty">
                        <i class="el-icon-folder-opened"></i>
                        <span>暂无点评类别，请点击上方「新增一级」</span>
                    </div>
                    <article
                        v-for="l1 in displayTree"
                        :key="l1.Id"
                        class="cat-group"
                        :class="{ 'is-open': isGroupOpen(l1.Id) }"
                    >
                        <div class="cat-group__head" @click="toggleGroup(l1.Id)">
                            <button class="cat-group__fold" type="button" tabindex="-1" :title="isGroupOpen(l1.Id) ? '收起' : '展开'">
                                <i :class="isGroupOpen(l1.Id) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                            </button>
                            <div class="cat-group__main">
                                <div class="cat-group__name">{{ l1.Name }}</div>
                                <div class="cat-group__meta">
                                    <span :class="['cat-tag', l1.IsEnabled ? 'cat-tag--green' : 'cat-tag--gray']">
                                        <i :class="l1.IsEnabled ? 'el-icon-check' : 'el-icon-close'"></i>
                                        {{ l1.IsEnabled ? '已启用' : '已停用' }}
                                    </span>
                                    <span class="cat-tag cat-tag--gray"><i class="el-icon-folder"></i> {{ (l1.Children && l1.Children.length) || 0 }} 个子类</span>
                                </div>
                            </div>
                            <div class="cat-group__ops" @click.stop>
                                <el-button type="text" size="mini" icon="el-icon-plus" class="cat-btn-add" @click="handleAddSub(l1)">添加二级</el-button>
                                <el-button type="text" size="mini" icon="el-icon-edit" class="cat-btn-edit" @click="handleEdit(l1)">编辑</el-button>
                                <el-button type="text" size="mini" icon="el-icon-delete" class="cat-btn-danger" @click="handleDel(l1)">删除</el-button>
                            </div>
                        </div>
                        <div v-show="isGroupOpen(l1.Id)" class="cat-group__body">
                            <div
                                v-for="l2 in (l1.Children || [])"
                                :key="l2.Id"
                                class="cat-child"
                            >
                                <div class="cat-child__main">
                                    <span class="cat-child__dot"></span>
                                    <span class="cat-child__name">{{ l2.Name }}</span>
                                    <span class="cat-child__count" :class="{ 'is-empty': !((l2.Items && l2.Items.length) || 0) }">
                                        <i class="el-icon-document-checked"></i>
                                        点评项 {{ (l2.Items && l2.Items.length) || 0 }}
                                    </span>
                                </div>
                                <div class="cat-child__ops">
                                    <el-button type="text" size="mini" icon="el-icon-document" class="cat-btn-subitem" @click="handleItems(l2)">点评项</el-button>
                                    <el-button type="text" size="mini" icon="el-icon-edit" class="cat-btn-edit" @click="handleEdit(l2)">编辑</el-button>
                                    <el-button type="text" size="mini" icon="el-icon-delete" class="cat-btn-danger" @click="handleDel(l2)">删除</el-button>
                                </div>
                            </div>
                            <div v-if="!(l1.Children && l1.Children.length)" class="cat-child--empty">
                                <span>当前分类下暂无二级类型，</span>
                                <span class="empty-add-btn" @click="handleAddSub(l1)"><i class="el-icon-plus"></i>立即添加二级</span>
                            </div>
                        </div>
                    </article>
                </div>
            </div>

            <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="420px" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="90px" :rules="editFormRules" ref="editForm">
                    <el-form-item v-if="editForm.Level === 2" label="一级分类" prop="ParentId">
                        <el-select v-model="editForm.ParentId" placeholder="请选择一级分类" style="width: 100%">
                            <el-option v-for="p in level1Options" :key="p.Id" :label="p.Name" :value="p.Id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="名称" prop="Name">
                        <el-input v-model="editForm.Name" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="排序号" prop="SortOrder">
                        <el-input-number v-model="editForm.SortOrder" :min="0" style="width: 100%"></el-input-number>
                    </el-form-item>
                    <el-form-item label="启用">
                        <el-switch v-model="editForm.IsEnabled"></el-switch>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editFormVisible = false">取 消</el-button>
                    <el-button type="primary" :loading="editLoading" @click="editSubmit">确 定</el-button>
                </div>
            </el-dialog>

            <el-dialog
                :title="currentCategory ? (currentCategory.Name + ' - 点评项') : '点评项'"
                :visible.sync="itemsDialogVisible"
                width="640px"
                :close-on-click-modal="false"
            >
                <div class="item-toolbar">
                    <el-button type="primary" icon="el-icon-plus" size="small" @click="openItem()">新增</el-button>
                </div>
                <el-table :data="pagedItems" v-loading="itemsLoading" style="width: 100%;">
                    <el-table-column prop="Name" label="点评项" min-width="160" align="center" show-overflow-tooltip />
                    <el-table-column prop="MaxScore" label="最高分" width="90" align="center"></el-table-column>
                    <el-table-column prop="SortOrder" label="排序" width="70" align="center"></el-table-column>
                    <el-table-column label="状态" width="80" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.IsEnabled ? '启用' : '停用' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="160" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" type="warning" @click="openItem(scope.row)">编辑</el-button>
                            <el-button size="mini" type="danger" @click="removeItem(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-container">
                    <el-pagination
                        layout="total, prev, pager, next"
                        :current-page="itemsPage"
                        :page-size="itemsPageSize"
                        :total="items.length"
                        @current-change="handleItemsPageChange"
                    ></el-pagination>
                </div>
            </el-dialog>

            <el-dialog :title="itemDialog.title" :visible.sync="itemDialog.visible" width="420px" append-to-body :close-on-click-modal="false">
                <el-form :model="itemDialog.form" label-width="80px">
                    <el-form-item label="名称">
                        <el-input v-model="itemDialog.form.Name" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="最高分">
                        <el-input-number v-model="itemDialog.form.MaxScore" :min="0.01" :max="1000" :precision="2"></el-input-number>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input-number v-model="itemDialog.form.SortOrder" :min="0"></el-input-number>
                    </el-form-item>
                    <el-form-item label="启用">
                        <el-switch v-model="itemDialog.form.IsEnabled"></el-switch>
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button @click="itemDialog.visible = false">取消</el-button>
                    <el-button type="primary" @click="saveItem">确定</el-button>
                </div>
            </el-dialog>

            <el-dialog :visible.sync="itemImportDialogVisible" width="860px" custom-class="person-import-dialog"
                :close-on-click-modal="false" append-to-body @closed="onItemImportDialogClosed">
                <div slot="title" class="pi-dialog-title">
                    <span class="pi-dialog-title__icon"><i class="el-icon-s-data"></i></span>
                    <div>
                        <strong>批量导入点评项</strong>
                        <p>下载模板填写后上传，学校以顶部所选为准</p>
                    </div>
                </div>
                <div class="pi-body">
                    <div class="pi-steps">
                        <div class="pi-step"><span class="pi-step__no">1</span><div><strong>下载模板</strong><em>按列填写分类与点评项</em></div></div>
                        <i class="el-icon-arrow-right pi-step__arrow"></i>
                        <div class="pi-step"><span class="pi-step__no">2</span><div><strong>上传 Excel</strong><em>支持 .xlsx / .xls</em></div></div>
                        <i class="el-icon-arrow-right pi-step__arrow"></i>
                        <div class="pi-step"><span class="pi-step__no">3</span><div><strong>核对导入</strong><em>预览后再确认写入</em></div></div>
                    </div>
                    <button type="button" class="pi-template-card" @click="downloadItemImportTemplate">
                        <span class="pi-template-card__icon"><i class="el-icon-document"></i></span>
                        <span class="pi-template-card__meta">
                            <strong>课堂质量点评项导入模板.xlsx</strong>
                            <em>含「填写说明」与示例行；无需填写学校</em>
                        </span>
                        <span class="pi-template-card__action"><i class="el-icon-download"></i>下载模板</span>
                    </button>
                    <el-upload :key="'cq-item-upload-' + itemImportUploadKey" class="pi-upload" drag action="#"
                        :auto-upload="false" :limit="1" :show-file-list="false" accept=".xlsx,.xls"
                        :on-change="onItemImportFileChange" :on-remove="onItemImportFileRemove" :on-exceed="onItemImportExceed">
                        <div v-if="itemImportFileRaw" class="pi-upload__file">
                            <i class="el-icon-success pi-upload__ok"></i>
                            <div><strong>{{ itemImportFileRaw.name }}</strong><em>已选择，点击「解析并预览」</em></div>
                        </div>
                        <div v-else class="pi-upload__empty">
                            <i class="el-icon-upload2"></i><strong>点击选择或拖拽 Excel 到此处</strong><em>仅支持 .xlsx / .xls</em>
                        </div>
                    </el-upload>
                </div>
                <div slot="footer" class="pi-footer">
                    <el-button @click="itemImportDialogVisible = false">关闭</el-button>
                    <el-button type="primary" icon="el-icon-view" :disabled="!itemImportFileRaw"
                        :loading="itemImportParsing" @click="parseItemImportFile">解析并预览</el-button>
                </div>
            </el-dialog>

            <el-dialog :visible.sync="excelShow" :close-on-click-modal="false" width="78%"
                custom-class="person-import-dialog" append-to-body
                :before-close="(done) => { this.backToItemImportSelect(); done(); }">
                <div slot="title" class="pi-dialog-title">
                    <span class="pi-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
                    <div><strong>点评项导入核对</strong><p>共 {{ outputs.length }} 条，确认无误后写入系统</p></div>
                </div>
                <el-table :data="pagedOutputs" class="pi-preview-table" border stripe style="width: 100%" max-height="520">
                    <el-table-column prop="CategoryLevel1" label="一级分类" min-width="120" show-overflow-tooltip />
                    <el-table-column prop="CategoryLevel2" label="二级分类" min-width="120" show-overflow-tooltip />
                    <el-table-column prop="ItemName" label="点评项" min-width="160" show-overflow-tooltip />
                    <el-table-column prop="MaxScore" label="最高分" width="90" show-overflow-tooltip />
                    <el-table-column prop="SortOrder" label="排序" width="80" show-overflow-tooltip />
                    <el-table-column label="操作" align="center" width="90">
                        <template slot-scope="scope">
                            <el-button type="text" class="pi-row-del" @click="removeImport(scope)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pi-preview-pager">
                    <el-pagination local-paging layout="total, prev, pager, next, jumper" :total="outputs.length"
                        :page-size="importPageSize" :current-page.sync="importPage"
                        @current-change="handleImportCurrentChange" @size-change="handleImportSizeChange" />
                </div>
                <div slot="footer" class="pi-footer">
                    <el-button @click="backToItemImportSelect">返回上一步</el-button>
                    <el-button type="primary" icon="el-icon-upload2" :disabled="!outputs.length" @click="SavaImport">确认导入</el-button>
                </div>
            </el-dialog>

            <import-result-dialog :visible.sync="importResultVisible" :result="importResult" />
        </section>
    </section>
</template>

<script>
import {
    getClassroomQualityCategoryTree,
    saveClassroomQualityCategory,
    deleteClassroomQualityCategory,
    saveClassroomQualityItem,
    deleteClassroomQualityItem,
    importClassroomQualityItems,
} from '../../api/modules/classroom-quality';
import { resolveActiveSchoolId } from '../../utils/deptCascaderProps';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';
import DepartmentPane from '../../components/DepartmentPane';
import ImportResultDialog from '../../components/ImportResultDialog';
import { normalizeImportBatchResponse } from '../../utils/importResultParser';
import { read, utils, writeFile } from 'xlsx';
import '../../style/person-import-dialog.css';

export default {
    name: 'ClassroomQualityItemConfig',
    components: { Toolbar, DepartmentPane, ImportResultDialog },
    data() {
        return {
            schoolId: 0,
            schoolName: '',
            filters: { name: '' },
            searchList: [{ label: '名称', key: 'name' }],
            tree: [],
            listLoading: false,
            expandedGroups: {},
            buttonList: [],
            dialogTitle: '',
            editFormVisible: false,
            editLoading: false,
            editFormRules: {
                Name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                ParentId: [{ required: true, message: '请选择一级分类', trigger: 'change' }],
            },
            editForm: {
                Id: 0,
                Level: 1,
                ParentId: null,
                Name: '',
                SortOrder: 0,
                IsEnabled: true,
            },
            itemsDialogVisible: false,
            itemsLoading: false,
            currentCategory: null,
            items: [],
            itemsPage: 1,
            itemsPageSize: 10,
            itemDialog: {
                visible: false,
                title: '',
                form: { Id: 0, CategoryId: 0, Name: '', MaxScore: 10, SortOrder: 0, IsEnabled: true },
            },
            outputs: [],
            excelShow: false,
            itemImportDialogVisible: false,
            itemImportFileRaw: null,
            itemImportParsing: false,
            itemImportUploadKey: 0,
            itemImportKeepFileOnClose: false,
            importResultVisible: false,
            importResult: null,
            importPage: 1,
            importPageSize: 10,
        };
    },
    computed: {
        pagedItems() {
            const start = (this.itemsPage - 1) * this.itemsPageSize;
            return (this.items || []).slice(start, start + this.itemsPageSize);
        },
        pagedOutputs() {
            const start = (this.importPage - 1) * this.importPageSize;
            return (this.outputs || []).slice(start, start + this.importPageSize);
        },
        level1Options() {
            return this.tree || [];
        },
        displayTree() {
            const keyword = (this.filters.name || '').trim();
            if (!keyword) return this.tree;
            return (this.tree || []).map(l1 => {
                const children = (l1.Children || []).filter(l2 => (l2.Name || '').indexOf(keyword) >= 0);
                const selfHit = (l1.Name || '').indexOf(keyword) >= 0;
                if (!selfHit && !children.length) return null;
                return { ...l1, Children: selfHit ? (l1.Children || []) : children };
            }).filter(Boolean);
        },
    },
    methods: {
        isGroupOpen(id) {
            return !!(this.expandedGroups && this.expandedGroups[id]);
        },
        toggleGroup(id) {
            if (!this.expandedGroups) this.$set(this, 'expandedGroups', {});
            this.$set(this.expandedGroups, id, !this.expandedGroups[id]);
        },
        resolveSchoolId() {
            // 学校 Id 用字符串，避免大整型精度丢失。最后修改：2026-10-18
            const fromStore = resolveActiveSchoolId(this);
            if (fromStore) return String(fromStore);
            if (this.schoolId) return String(this.schoolId);
            return '';
        },
        treeNodeClick(data) {
            const nextId = data && (data.value != null ? data.value : data.Id);
            const nextKey = nextId != null && nextId !== '' ? String(nextId) : '';
            this.schoolName = (data && (data.label || data.Name)) || '';
            if (!nextKey) return;
            if (String(this.schoolId || '') === nextKey && this.schoolId) return;
            this.schoolId = nextKey;
            this.handleQuery();
        },
        callFunction(item) {
            if (typeof item.search === 'object') this.filters = { ...this.filters, ...item.search };
            else this.filters = { ...this.filters, name: item.search };
            if (item.Func && typeof this[item.Func] === 'function') this[item.Func]();
            else this.handleQuery();
        },
        handleQuery(keepExpanded = true) {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) return;
            this.listLoading = true;
            getClassroomQualityCategoryTree({ schoolId }).then(res => {
                const list = (res.data && res.data.response) || [];
                this.tree = list;
                const hasKeyword = !!(this.filters && this.filters.name && String(this.filters.name).trim());
                if (hasKeyword) {
                    const expanded = { ...(this.expandedGroups || {}) };
                    (this.displayTree || list || []).forEach(item => {
                        if (item && item.Id) expanded[item.Id] = true;
                    });
                    this.expandedGroups = expanded;
                } else if (keepExpanded) {
                    const nextExpanded = { ...(this.expandedGroups || {}) };
                    this.expandedGroups = nextExpanded;
                } else {
                    this.expandedGroups = {};
                }
            }).finally(() => { this.listLoading = false; });
        },
        handleAdd() {
            this.openCategory(1, null);
        },
        handleAddLevel2() {
            if (!this.tree.length) {
                this.$message.warning('请先添加一级分类');
                return;
            }
            this.openCategory(2, this.tree[0]);
        },
        handleAddSub(row) {
            this.openCategory(2, row);
        },
        handleEdit(row) {
            this.openCategory(row.Level, null, row);
        },
        openCategory(level, parent, current) {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) {
                this.$message.warning('请先选择学校');
                return;
            }
            this.dialogTitle = current ? '编辑分类' : (level === 1 ? '新增一级分类' : '新增二级分类');
            this.editForm = current
                ? {
                    Id: current.Id,
                    Level: current.Level,
                    ParentId: current.ParentId,
                    Name: current.Name,
                    SortOrder: current.SortOrder,
                    IsEnabled: current.IsEnabled,
                }
                : {
                    Id: 0,
                    Level: level,
                    ParentId: parent ? parent.Id : null,
                    Name: '',
                    SortOrder: 0,
                    IsEnabled: true,
                };
            this.editFormVisible = true;
        },
        editSubmit() {
            this.$refs.editForm.validate(valid => {
                if (!valid) return;
                this.editLoading = true;
                const formPayload = {
                    ...this.editForm,
                    SchoolId: this.resolveSchoolId(),
                };
                saveClassroomQualityCategory(formPayload).then(res => {
                    if (res.data && res.data.success) {
                        this.$message.success(res.data.msg || '保存成功');
                        this.editFormVisible = false;

                        const targetParentId = formPayload.Level === 2 ? formPayload.ParentId : null;
                        const newId = formPayload.Id || (res.data.response && (res.data.response.Id || res.data.response));
                        if (targetParentId) {
                            this.$set(this.expandedGroups, targetParentId, true);
                        } else if (newId) {
                            this.$set(this.expandedGroups, newId, true);
                        }

                        this.handleQuery(true);
                    } else {
                        this.$message.error((res.data && res.data.msg) || '保存失败');
                    }
                }).finally(() => { this.editLoading = false; });
            });
        },
        handleDel(row) {
            this.$confirm(`确认删除「${row.Name}」？`, '提示', { type: 'warning' }).then(() => {
                deleteClassroomQualityCategory({ id: row.Id }).then(res => {
                    if (res.data && res.data.success) {
                        this.$message.success(res.data.msg || '已删除');
                        this.handleQuery();
                    } else {
                        this.$message.error((res.data && res.data.msg) || '删除失败');
                    }
                });
            }).catch(() => {});
        },
        handleItems(row) {
            this.currentCategory = row;
            this.items = row.Items || [];
            this.itemsPage = 1;
            this.itemsDialogVisible = true;
        },
        handleItemsPageChange(page) {
            this.itemsPage = page;
        },
        openItem(current) {
            if (!this.currentCategory) return;
            this.itemDialog.title = current ? '编辑点评项' : '新增点评项';
            this.itemDialog.form = current
                ? {
                    Id: current.Id,
                    CategoryId: this.currentCategory.Id,
                    Name: current.Name,
                    MaxScore: current.MaxScore,
                    SortOrder: current.SortOrder,
                    IsEnabled: current.IsEnabled,
                }
                : {
                    Id: 0,
                    CategoryId: this.currentCategory.Id,
                    Name: '',
                    MaxScore: 10,
                    SortOrder: 0,
                    IsEnabled: true,
                };
            this.itemDialog.visible = true;
        },
        saveItem() {
            if (!this.itemDialog.form.Name) {
                this.$message.warning('请输入名称');
                return;
            }
            saveClassroomQualityItem(this.itemDialog.form, this.resolveSchoolId()).then(res => {
                if (res.data && res.data.success) {
                    this.$message.success(res.data.msg || '保存成功');
                    this.itemDialog.visible = false;
                    this.reloadItems();
                } else {
                    this.$message.error((res.data && res.data.msg) || '保存失败');
                }
            });
        },
        removeItem(row) {
            this.$confirm(`确认删除「${row.Name}」？`, '提示', { type: 'warning' }).then(() => {
                deleteClassroomQualityItem({ id: row.Id }).then(res => {
                    if (res.data && res.data.success) {
                        this.$message.success(res.data.msg || '已删除');
                        this.reloadItems();
                    } else {
                        this.$message.error((res.data && res.data.msg) || '删除失败');
                    }
                });
            }).catch(() => {});
        },
        reloadItems() {
            const catId = this.currentCategory && this.currentCategory.Id;
            getClassroomQualityCategoryTree({ schoolId: this.resolveSchoolId() }).then(res => {
                this.tree = (res.data && res.data.response) || [];
                if (!catId) return;
                const l2 = this.findLevel2(catId);
                this.currentCategory = l2 || this.currentCategory;
                this.items = (l2 && l2.Items) || [];
                const maxPage = Math.max(1, Math.ceil(this.items.length / this.itemsPageSize) || 1);
                if (this.itemsPage > maxPage) this.itemsPage = maxPage;
            });
        },
        findLevel2(id) {
            for (let i = 0; i < this.tree.length; i++) {
                const children = this.tree[i].Children || [];
                const hit = children.find(x => x.Id === id);
                if (hit) return hit;
            }
            return null;
        },
        ImportCensus() {
            this.resetItemImportDialog();
            this.itemImportDialogVisible = true;
        },
        resetItemImportDialog() {
            this.itemImportFileRaw = null;
            this.itemImportParsing = false;
            this.itemImportUploadKey += 1;
        },
        onItemImportDialogClosed() {
            if (this.itemImportKeepFileOnClose) {
                this.itemImportKeepFileOnClose = false;
                return;
            }
            this.resetItemImportDialog();
        },
        backToItemImportSelect() {
            this.excelShow = false;
            this.itemImportDialogVisible = true;
        },
        onItemImportFileChange(file) {
            this.itemImportFileRaw = file && file.raw ? file.raw : null;
        },
        onItemImportFileRemove() {
            this.itemImportFileRaw = null;
        },
        onItemImportExceed(files) {
            const nextFile = files && files[0];
            if (!nextFile) return;
            this.itemImportUploadKey += 1;
            this.$nextTick(() => { this.itemImportFileRaw = nextFile; });
        },
        downloadItemImportTemplate() {
            const headers = ['一级分类', '二级分类', '点评项', '最高分', '排序'];
            const samples = [
                ['教学常规', '课堂组织', '教学目标明确', 10, 1],
                ['教学常规', '课堂组织', '环节衔接顺畅', 10, 2],
                ['教学效果', '学生参与', '学生积极互动', 10, 1],
            ];
            const dataSheet = utils.aoa_to_sheet([headers, ...samples]);
            dataSheet['!cols'] = [
                { wch: 14 }, { wch: 14 }, { wch: 28 }, { wch: 10 }, { wch: 8 },
            ];
            const tipRows = [
                ['课堂质量点评项批量导入 — 填写说明'],
                [''],
                ['一、基本规则'],
                ['1. 学校以系统顶部当前所选学校为准，模板中无需填写学校。'],
                ['2. 「一级分类」「二级分类」「点评项」「最高分」必填；名称均不超过 50 字。'],
                ['3. 「排序」可选，不填视为 0。'],
                ['4. 最高分须大于 0，且不超过 1000。'],
                [''],
                ['二、同名处理'],
                ['1. 同一学校下，一级分类、二级分类按名称匹配；不存在则自动创建。'],
                ['2. 同一二级分类下点评项同名时，更新最高分与排序，不会重复新增。'],
                [''],
                ['三、示例说明'],
                ['「点评项导入」工作表中已附示例行，可对照修改或删除后填写真实数据。'],
                ['导入前请删除不需要的示例行，避免误写入系统。'],
            ];
            const tipSheet = utils.aoa_to_sheet(tipRows);
            tipSheet['!cols'] = [{ wch: 88 }];
            const book = utils.book_new();
            utils.book_append_sheet(book, dataSheet, '点评项导入');
            utils.book_append_sheet(book, tipSheet, '填写说明');
            writeFile(book, '课堂质量点评项导入模板.xlsx');
        },
        parseItemImportFile() {
            if (!this.itemImportFileRaw) {
                this.$message.warning('请先选择 Excel 文件');
                return;
            }
            const file = this.itemImportFileRaw;
            if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
                this.$message.error('上传格式不正确，请上传 xls 或 xlsx 格式');
                return;
            }
            this.itemImportParsing = true;
            const fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    const workbook = read(ev.target.result, { type: 'binary' });
                    const ws = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
                    this.outputs = this.reSetKey(ws);
                    this.importPage = 1;
                    this.itemImportParsing = false;
                    this.itemImportKeepFileOnClose = true;
                    this.itemImportDialogVisible = false;
                    this.excelShow = true;
                } catch (e) {
                    this.itemImportParsing = false;
                    this.$message.error('文件读取失败');
                }
            };
            fileReader.onerror = () => {
                this.itemImportParsing = false;
                this.$message.error('文件读取失败');
            };
            fileReader.readAsBinaryString(file);
        },
        showImportResult(resData) {
            this.importResult = (resData && resData.response) || null;
            this.importResultVisible = true;
            const normalized = normalizeImportBatchResponse(resData || {});
            if (!normalized.items.length) {
                const text = normalized.summary || (resData && resData.msg) || '';
                if (text) this.$message.success(text);
            }
        },
        removeImport(e) {
            const name = e.row.ItemName || e.row.CategoryLevel1 || '该行';
            this.$confirm('确定要删除 ' + name + ' 的信息?').then(() => {
                const realIndex = (this.importPage - 1) * this.importPageSize + e['$index'];
                this.outputs.splice(realIndex, 1);
                if (this.importPage > 1 && this.pagedOutputs.length === 0) {
                    this.importPage = this.importPage - 1;
                }
            });
        },
        SavaImport() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) {
                this.$message.warning('请先选择学校');
                return;
            }
            if (!this.outputs.length) {
                this.$message.warning('没有可导入的数据，请检查导入内容');
                return;
            }
            const loading = this.$loading({ lock: true, text: '导入中', background: 'rgba(0, 0, 0, 0.7)' });
            importClassroomQualityItems({ schoolId, items: this.outputs })
                .then((res) => {
                    loading.close();
                    if (res.data && res.data.success) {
                        this.excelShow = false;
                        this.showImportResult(res.data);
                        this.handleQuery();
                    } else {
                        this.showImportResult(res.data || {});
                        if (!this.importResult) {
                            this.$message.error((res.data && res.data.msg) || '导入失败');
                        }
                    }
                })
                .catch(() => {
                    loading.close();
                    this.$message.error('导入失败');
                });
        },
        reSetKey(ws) {
            const temp = [];
            (ws || []).forEach((item) => {
                const level1 = String(item['一级分类'] || item['CategoryLevel1'] || '').trim();
                const level2 = String(item['二级分类'] || item['CategoryLevel2'] || '').trim();
                const itemName = String(item['点评项'] || item['评价项目'] || item['ItemName'] || '').trim();
                const rawScore = item['最高分'] || item['MaxScore'];
                let parsedScore = rawScore === undefined || rawScore === '' ? 0 : parseFloat(rawScore);
                parsedScore = isNaN(parsedScore) ? 0 : parsedScore;
                const rawSort = item['排序'] || item['SortOrder'];
                let parsedSort = 0;
                if (rawSort !== undefined && rawSort !== null && rawSort !== '') {
                    const n = parseInt(rawSort, 10);
                    parsedSort = isNaN(n) ? 0 : n;
                }
                if (!level1 && !level2 && !itemName) return;
                temp.push({
                    CategoryLevel1: level1,
                    CategoryLevel2: level2,
                    ItemName: itemName,
                    MaxScore: parsedScore,
                    SortOrder: parsedSort,
                });
            });
            return temp;
        },
        handleImportCurrentChange(page) {
            this.importPage = page;
        },
        handleImportSizeChange(size) {
            this.importPageSize = size;
            this.importPage = 1;
        },
    },
    mounted() {
        const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        if (!this.buttonList.some(b => b.Func === 'handleQuery')) {
            this.buttonList.unshift({ name: '查询', Func: 'handleQuery', id: 991 });
        }
        if (!this.buttonList.some(b => b.Func === 'handleAdd')) {
            this.buttonList.push({ name: '添加一级类型', Func: 'handleAdd', id: 992, type: 'success' });
        }
        if (!this.buttonList.some(b => b.Func === 'handleAddLevel2')) {
            this.buttonList.push({ name: '添加二级类型', Func: 'handleAddLevel2', id: 993, type: 'success' });
        }
        if (!this.buttonList.some(b => b.Func === 'ImportCensus')) {
            this.buttonList.push({ name: '导入', Func: 'ImportCensus', id: 994 });
        }
    },
};
</script>

<style scoped>
.muted-dash {
    color: #c0c4cc;
}
.item-toolbar { margin-bottom: 12px; }
.pagination-container {
    margin-top: 12px;
    text-align: right;
}
</style>
